import script from "./SearchSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchSection.vue?vue&type=script&setup=true&lang=js"

import "./SearchSection.vue?vue&type=style&index=0&id=5126e823&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5126e823"]])

export default __exports__